'use strict';

var variadic = require('../helpers/variadic');

module.exports = function has() {
  var _this = this;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var properties = variadic(args);
  return properties.filter(function (key) {
    return Object.hasOwnProperty.call(_this.items, key);
  }).length === properties.length;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/has.js
// module id = 1666
// module chunks = 2